import React from "react";
import { motion } from "framer-motion";

// Scroll-triggered reveal wrapper
export const Reveal = ({ children, delay = 0, y = 40, className = "", once = true }) => (
  <motion.div
    className={className}
    initial={{ opacity: 0, y }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once, amount: 0.25 }}
    transition={{ duration: 0.9, delay, ease: [0.19, 1, 0.22, 1] }}
  >
    {children}
  </motion.div>
);

// Masked line reveal for large headings.
// The whileInView trigger sits on the STATIC outer span so it fires reliably;
// the inner span (translated 110%) is driven via variants.
export const LineReveal = ({ children, delay = 0, className = "" }) => (
  <motion.span
    className="reveal-line block"
    initial="hidden"
    whileInView="show"
    viewport={{ once: true, amount: 0.2 }}
  >
    <motion.span
      className={"block " + className}
      variants={{ hidden: { y: "110%" }, show: { y: "0%" } }}
      transition={{ duration: 1, delay, ease: [0.19, 1, 0.22, 1] }}
    >
      {children}
    </motion.span>
  </motion.span>
);

export const Overline = ({ children, dark = false }) => (
  <div className="flex items-center gap-3">
    <span className={"h-px w-8 " + (dark ? "bg-gold" : "bg-gold")} />
    <span className={"overline " + (dark ? "text-gold-light" : "text-gold")}>{children}</span>
  </div>
);
